module.exports = __webpack_public_path__ + "img/EnergyWeapons.115330b7.png";